import Page from "components/Page"
import Content from "components/Content"
import HappinessGuaranteeView from "../../components/HappinessGuaranteeView"

const HappinessGuaranteePage = () => <Page title='Happiness Guarantee' width='wide'>
  <Content width='wide'>
    <HappinessGuaranteeView />
  </Content>
</Page>

export default HappinessGuaranteePage
